import { LinkListElementElementModel, LinkListGroupElementElementModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import LinkList from '@shared/components/LinkList.tsx';

interface ILinkListGroupProps {
    element: LinkListGroupElementElementModel;
}
const LinkListGroup = ({ element }: ILinkListGroupProps) => {
    return (
        <div className={'mb-7'}>
            <h2>{element.properties?.heading}</h2>
            {element.properties?.text?.markup && (
                <div
                    className=''
                    dangerouslySetInnerHTML={{ __html: element.properties.text.markup }}
                />
            )}
            {element.properties?.linkListGroups?.items &&
                element.properties.linkListGroups?.items.map((linkList, key) => {
                    const element = linkList.content as LinkListElementElementModel;
                    return (
                        <LinkList
                            element={element}
                            key={key}
                        />
                    );
                })}
        </div>
    );
};
export default LinkListGroup;
